/**
 * @generated SignedSource<<e487aff5e9800cf59dc4ae94736c1468>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalFeedbackSummaryFragment$data = {
  readonly feedbackAggregates: {
    readonly negativeFeedback: {
      readonly amount: string;
    };
    readonly positiveFeedback: {
      readonly amount: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ProposalFeedbackSummaryVotesBarFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProposalFeedbackSummaryVoteTimeFragment">;
  readonly " $fragmentType": "ProposalFeedbackSummaryFragment";
};
export type ProposalFeedbackSummaryFragment$key = {
  readonly " $data"?: ProposalFeedbackSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalFeedbackSummaryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalFeedbackSummaryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackAggregates",
      "kind": "LinkedField",
      "name": "feedbackAggregates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "positiveFeedback",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "negativeFeedback",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProposalFeedbackSummaryVotesBarFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProposalFeedbackSummaryVoteTimeFragment"
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};
})();

(node as any).hash = "15da1e0a31a5e5f9901b58b803b013ee";

export default node;
